// @flow

// Libs
import { createSelector } from 'reselect'
import _filter from 'lodash/filter'
import _map from 'lodash/map'
import _isEmpty from 'lodash/isEmpty'
import extent from 'turf-extent'

// utils
import traverse from 'fc-utils/traverse'

// Types
import type {
  Asset,
} from 'fc-model-assets/types'

// Selectors
import { fieldsOfSelectedFarmAndSeason$ } from 'hfty-assets'

// Constants
import { PROP_SHAPE } from 'fc-model-assets'
import {
  PROP_SHAPE_DATA,
  PROP_FEATURES,
} from 'fc-model-shapes'
import { FEATURECOLLECTION } from 'fc-utils/geoJson'

export default createSelector(
  [fieldsOfSelectedFarmAndSeason$],
  function (fields: Array<Asset>): Array<Array<number>> {
    const fieldShapes = _filter(fields, (field: Asset): Array<Asset> => field[PROP_SHAPE])
    let fieldFeatures = _map(fieldShapes, (field: Asset): Array<Asset> => ({
      ...traverse([PROP_SHAPE, PROP_SHAPE_DATA, PROP_FEATURES, 0], {default: {}})(field),
    }))
    fieldFeatures = _filter(fieldFeatures, (feature: Object): boolean => !_isEmpty(feature))

    if (fieldFeatures.length) {
      const fieldFeatureCollection = {
        type: FEATURECOLLECTION,
        features: fieldFeatures,
      }

      const [y1, x1, y2, x2] = extent(fieldFeatureCollection)

      return [[x1, y1], [x2, y2]]
    }

    return []
  }
)
